// extracted by mini-css-extract-plugin
export var linkedIn = "linkedIn-module--linkedIn--xPWCO";